<template>
  
    <div class="mt-10 text-center" :key="isArabic">

        <div v-if="myData.length > 0" class="overflow-hidden">

            <vue-horizontal-list
            :items="myData"
            >
            <template v-slot:default="{item}" :options="options" >
                <!-- <div @click="echo(item)" class="bg-blue-400 w1/2 text-white myCenter items-center text-xl" style="height: 100px;" > -->
                <div class="bg-blue-400 text-white myCenter items-center text-xl" style="height: 100px;" >

                <h5 class="flex justify-center" style="width:100px;">{{item.title}}</h5>
                
                <!-- <p>{{item.img}}</p> -->
                </div>
            </template>
            </vue-horizontal-list>
            
        </div>

    </div>
</template>

<script>

import VueHorizontalList from "vue-horizontal-list";

export default {

    mounted(){

        this.setData()
    },

    components:{

       VueHorizontalList 
    },

    methods:{

        setData(){

            this.myData =  [

                {
                    index: 0,
                    title: this.$t('ads.listAd1'),
                    img: require('@/assets/images/swiper-dance.jpg')
                },
                {
                    index: 1,
                    title: this.$t('ads.listAd2'),
                    img: require('@/assets/images/swiper-class.jpg')
                },
                {
                    index: 2,
                    title: this.$t('ads.listAd3'),
                    img: require('@/assets/images/swiper-ma.jpg')
                },
                {
                    
                    index: 3,
                    title: this.$t('ads.listAd4'),
                    img: require('@/assets/images/swiper-gym.jpg')
                },
                {
                    
                    index: 4,
                    title: this.$t('ads.listAd5'),
                    img: require('@/assets/images/swiper-workout.jpg')
                },
            ];
        }
    },

    data: function(){

        return {

            myData: new Array(),

            isArabic: this.$i18n.locale == 'ar' ?  true: false,

            options: {
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { start: 768, end: 992, size: 3 },
                { size: 4 },
                ],

                list:{

                    padding: 0
                }
            },
        }
    },

    watch:{

        '$i18n.locale'(newValue) {

            
                this.setData();

            // this.isArabic =  this.$i18n.locale == 'ar';

        },
    }
}
</script>

<style>

</style>